import { SectionKey } from './search-edition-params';

export interface SearchEditionPagination {
    'page': number;
    'limit': number;
}

export interface SearchEditionResultRow {
    'id': string;
    'pos': number;
    'total': number;
    'doc': string;
    'kwic': string;
    'context': Array<string>;
    'section': SectionKey;
}

export type SearchEditionResults = Array<SearchEditionResultRow>;

export function extractKwicInnerHtml(kwic: string): string {
    if (kwic) {
        const domParser = new DOMParser();
        const kwicDom = domParser.parseFromString(kwic, 'text/xml');
        return kwicDom.documentElement.innerHTML;
    } else {
        return '';
    }
}

export function isTeiHeadKwic(kwic: string): boolean {
    return kwic.substring(0, 10) === '<data-head';
}



// WEBPACK FOOTER //
// ./src/app/models/search-edition-results.ts